import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { esportRouteI18n } from '../i18n/esport-route-i18n';

export function esportRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${esportRouteI18n()}`;
}
